import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global smooth scroll via Lenis. Rendered once in App.js.
 * Registers a rAF loop; disposes on unmount.
 */
export default function SmoothScroll() {
  useEffect(() => {
    // Disable smooth scroll for admin & portal (they benefit from native scroll perf)
    const path = window.location.pathname;
    if (path.startsWith("/admin") || path.startsWith("/portal")) return undefined;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.2,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
}
